// src/components/shared/LastMessage.js
import React from "react";
import PropTypes from "prop-types";
import { NO_MESSAGES_YET,DELETE_MESSAGES_TEXT,YOU_DELETE_MESSAGES_TEXT } from "../../constants";

const LastMessage = ({ text }) => {
  let displayText = text || NO_MESSAGES_YET;
  if (displayText === DELETE_MESSAGES_TEXT) {
    displayText = YOU_DELETE_MESSAGES_TEXT;
  }
  const cleanedText = displayText.replace(/\s+/g, " ").trim();

  return (
    <div className="message-wrapper">
      <div className="truncate-ellipsis">{cleanedText}</div>
    </div>
  );
};

LastMessage.propTypes = {
  text: PropTypes.string,
};

export default LastMessage;
